import { useCallback, useEffect, useState, useRef } from 'react';

import { Helmet } from 'react-helmet';

import styles from './OldSite.module.css';
import { siteDescription } from '../old-site/data/projects.js';
import Header from '../old-site/components/Header.js';
import ProjectCoordinator from '../old-site/components/ProjectCoordinator.js';

function OldSite() {

    return (
        <div className={styles.oldSite}>
            <Helmet>
                <title>Jonathan Liew | Design</title>
                <meta
                    name="description"
                    content={siteDescription}
                />
            </Helmet>
            <Header />
            <ProjectCoordinator />
        </div>


    );
}

export default OldSite;
